import React, { ButtonHTMLAttributes, FC, MouseEvent } from 'react';
import { styled } from 'linaria/react';
interface SwitcherProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'value'> {
  value: boolean;
  onSwitchEnable: (e: MouseEvent<HTMLButtonElement>) => void;
  onSwitchDisable: (e: MouseEvent<HTMLButtonElement>) => void;
}
const Switcher: FC<SwitcherProps> = ({
  value,
  onSwitchEnable,
  onSwitchDisable,
  ...rest
}) => {
  const handleSwitch = (e: MouseEvent<HTMLButtonElement>) => {
    if (value) {
      onSwitchDisable(e);
    } else {
      onSwitchEnable(e);
    }
  };
  return <SwitcherWrapper active={value} onClick={handleSwitch} {...rest}>
      <Circle active={value} />
    </SwitcherWrapper>;
};
export default Switcher;
interface SwitcherWrapperProps {
  active: boolean;
}
const _exp = /*#__PURE__*/() => ({
  active
}) => active ? '#26CD58' : '#bcc3d080';
const SwitcherWrapper = /*#__PURE__*/styled('button')({
  name: "SwitcherWrapper",
  class: "s1e8s7a0",
  propsAsIs: false,
  vars: {
    "s1e8s7a0-0": [_exp()]
  }
});
interface CircleProps {
  active: boolean;
}
const _exp2 = /*#__PURE__*/() => ({
  active
}) => active ? '18px' : '0';
const Circle = /*#__PURE__*/styled('div')({
  name: "Circle",
  class: "cj8d8ng",
  propsAsIs: false,
  vars: {
    "cj8d8ng-0": [_exp2()]
  }
});

require("./Switcher.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Switcher.tsx");